import { Component, Vue, Prop } from 'vue-property-decorator'
import '../../assets/css/AmDropdownMenuV2.scss'

type MenuItems = {
  label: string
  command: string
  icon: string
  disabled: boolean
  divided: boolean
  group?: string
}

@Component({
  name: 'AmDropdownMenuMixinV2',
})
export default class extends Vue {
  @Prop({ type: String, default: '下拉菜单' }) readonly title!: string
  @Prop(Boolean) readonly customElm!: boolean
  @Prop({ default: true }) readonly scrollable!: boolean
  @Prop({ default: false }) readonly loading!: boolean
  @Prop({ default: false }) readonly isEcho!: boolean
  @Prop(Boolean) readonly isCustom!: boolean
  @Prop(String) readonly placement!: string
  @Prop(String) readonly trigger!: string
  @Prop({ default: true }) readonly hideOnClick!: boolean
  @Prop(Boolean) readonly disabled!: boolean
  @Prop({ default: 'primary' }) readonly type!: string
  @Prop(String) readonly size!: string
  @Prop({ default: '' }) readonly icon!: Record<string, any>
  @Prop(String) readonly width?: string
  @Prop({ default: 150 }) readonly showTimeout?: number
  @Prop({ default: 150 }) readonly hideTimeout?: number
  @Prop({ default: 0 }) readonly tabindex?: number
  @Prop(Array) readonly menuItems!: MenuItems[]

  iconClass: string = 'yxt-icon-arrow-down'

  currentVal: MenuItems | string = ''

  get panelStyle() {
    return {
      width: this.isCustom ? this.width : 'auto',
      minWidth: this.isCustom ? this.width : '120px',
    }
  }

  get iconObj() {
    // 旧数据兼容（原为string类型）
    return this.icon
      ? typeof this.icon == 'string'
        ? JSON.parse(this.icon)
        : this.icon
      : {}
  }

  get iconType() {
    return this.iconObj?.iconType || ''
  }
  get iconName() {
    return this.iconObj?.value || ''
  }

  get menuClass() {
    return this.isCustom
      ? 'lc-am-dropdown-menu__content--custom'
      : 'lc-am-dropdown-menu__content'
  }

  get desc() {
    return this.isEcho ? this.currentVal || this.title : this.title
  }

  handleVisibleChange(visible) {
    if (!this.customElm) return
    if (visible) this.iconClass = 'yxt-icon-arrow-up'
    else this.iconClass = 'yxt-icon-arrow-down'
  }

  commandChange(command) {
    const item = this.menuItems.find(item => item.command === command)

    if (item) {
      this.currentVal = item.label
    }
  }

  // 转换 menuItems 用来支持分组功能
  get menuItemsData() {
    const menuItems = [] as Record<string, any>[]

    this.menuItems.forEach(item => {
      if (item.group) {
        const group = menuItems.find(group => group.group === item.group)
        if (group) {
          group.children?.push(item)
        } else {
          menuItems.push({ group: item.group, children: [item] })
        }
      } else {
        menuItems.push(item)
      }
    })

    return menuItems
  }
}
